<template>
    <small
        v-if="isShownForTesting"
        class="pl-3 redirect-app align-content-center"
    >
        <a
            :href="ciUrl"
            target="_blank"
            v-b-tooltip.hover="{
                placement: 'right',
                title: title
            }"
        >
            <i class="fa-link fas icon"></i> APP
        </a>
    </small>
</template>

<script>
export default {
    name: "redirectToApp",
    props: {
        ciUrl: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    async mounted() {},
    computed: {
        isShownForTesting() {
            return (
                this.ciUrl &&
                (process.env.VUE_APP_ENV === "local" ||
                    process.env.VUE_APP_ENV === "QA" ||
                    (process.env.VUE_APP_ENV === "PROD" &&
                        (this._setting.business_id === "0000000000000261" || // Teakwood Palace
                            this._setting.business_id === "8463bf0b-54cd-11"))) // Automation Palace
            );
        },
        title() {
            return `For testing only available in QA, local and Prod (Teakwood Palace - 0000000000000261,Automation Palace - 8463bf0b-54cd-11)`;
        }
    },
    methods: {}
};
</script>
<style scoped>
.redirect-app {
    font-size: medium;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}
.icon {
    font-size: xx-small;
    vertical-align: middle;
}
</style>
